import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
export const adminGetInitialProductsByDropIdEndpoint = {
    authentication: authenticationTypes.authenticated,
    authenticationRole: userGroups.admin,
    endpointType: otherEndpointType,
    payloadSchema: {
        type: 'object',
        properties: {
            dropId: {
                type: 'string',
            },
            includePrecedingDrops: {
                type: 'boolean',
            },
        },
        required: ['dropId'],
    },
};
